import { createReducer } from '../../utilities';
import {
    SUCCESS_FETCH_STATS_BADGES
} from "../../../actions/entities/statistics/badges";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_BADGES]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/badges.js